// CSS 

//Lib 
import moment from 'moment';

// Api  
import api from '@/api/baseApi';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import base from '@/scripts/base';

// Component   

// Function  

export default {

  extends: base,

  components: {
  },

  data() {
    return {
      disabledSaveChanges: true,
      request: {
        bootSuccess: true,
        recharge: true,
        balanceChange: true,
        promotion: true,
        advertisement: true,
      }
    }
  },

  created() {
    this.userSettingsView();
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion     

    //#region Notification change
    change() {
      this.disabledSaveChanges = false;
    },
    //#endregion

    //#region Notification ___ View
    userSettingsView() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_USER_API.NOTIFICATION_SETTINGS_VIEW, null)
        .then((res) => {
          let responsedData = res.data;
          this.request = responsedData;
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch(error => {
          this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
        });
    },
    //#endregion 

    //#region Notification ___ Modify
    modify() {
      let data = {
        bootSuccess: this.request.bootSuccess,
        recharge: this.request.recharge,
        balanceChange: this.request.balanceChange,
        promotion: this.request.promotion,
        advertisement: this.request.advertisement,
        deviceInformation: JSON.stringify(this.getInformationClient())
      }
      api.baseRequest(SETTINGS_USER_API.NOTIFICATION_SETTINGS_MODIFY, data)
        .then(() => {
          this.notificationSuccess(this.$t('bootMachine.renewalSuccessTitle'), this.$t('fixedRentalSettings.saveSuccessMessage'));
          this.disabledSaveChanges = true;
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
        })
        .catch(error => {
          this.notificationError(this.$t('notificationSettings.errorTitle'), this.$t('notificationSettings.unexpectedError'));
          this.processCatchApiRequest(error, this.$t('bootMachine.bootFailed'))
        });
    },
    //#endregion
  },
}